// Tipi di riparazione riutilizzati dal form dispositivi (DeviceForm PROBLEM_OPTIONS).
export const REPAIR_TYPES = [
  'Schermo', 'Batteria', 'Software', 'Connettore', 'Fotocamera',
  'Autoparlante', 'Cassa', 'Microfono', 'Acqua', 'NonSiAccende', 'Reset', 'Altro'
];

// Restituisce l'etichetta tradotta di un tipo di riparazione (valore grezzo -> etichetta).
export const getRepairTypeLabel = (value, t) => {
  if (!value) return '';
  const key = `models.device.problems.${value}`;
  const translated = t(key);
  return translated === key ? value : translated;
};

// Converte un tipo di riparazione del preventivo nei campi "Problemi" del DeviceForm.
// I valori non in lista sono considerati testi personalizzati ("Altro" + testo).
export const getProblemsFromRepairType = (repairType) => {
  if (!repairType) return { problems: [''], customProblems: [''] };
  if (REPAIR_TYPES.includes(repairType)) {
    return { problems: [repairType], customProblems: [''] };
  }
  return { problems: ['Altro'], customProblems: [repairType] };
};
